import UpdateCustomer from './Update';
export default UpdateCustomer;